import apiConfig from "../../config/apiConfig";
import { END_POINT,AUDIENCES_TYPE } from "../constants";
import { setError } from "./errorAction";
import { hideLoading, showLoading } from "./loadingAction";
import { objToQueryString } from "../../services/helpers/Helper";

export const getAudiences = (currentPage = 1, page_size = 10, searchName = '') => async(dispatch, getState) =>{
    const { page } = getState();
    const params = {
        fb_page_id: page.social_id,
        page : currentPage,
        page_size,
    }

    const body = {
        freetext : searchName
    }
    const qs = objToQueryString(params);
    const endPoint = `${END_POINT.AUDIENCES}?${qs}`;
    dispatch(showLoading());
    apiConfig.post(endPoint, body).then((response) => {
        dispatch({
            type: AUDIENCES_TYPE.GET,
            payload: response.data,
        });
    }).catch((error) => {
        dispatch(setError(error.message));
    }).finally(() => {
        dispatch(hideLoading());
    });
}

